// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"ed22abff","103":"1087ecf8","695":"d2f63449"}[chunkId] + ".chunk.css";
};